// src/services/emailPlaceholderService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getPlaceholderCatalog() {
    return apiRequest(endpoints.EmailPlaceholders, { method: 'GET' });
}

export function getEmailCenterConfig() {
    return apiRequest(endpoints.EmailConfig, { method: 'GET' });
}
